import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowUpRight, BookOpen } from "lucide-react";
import { SEO } from "@/components/SEO";
import { C, DISPLAY, BODY, MONO, Reveal, EditorialLabel, EditorialHeader, Section, Heading, EBtn } from "@/styles/editorial";

export default function BlogPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: C.white, fontFamily: BODY }}>
      <SEO
        title="Blog"
        description="Blog de Emergencia Animal. Noticias, actualizaciones y artículos sobre protección animal en emergencias."
        path="/blog"
      />
      <EditorialHeader backLabel="Volver al Hub" backTo="/" />

      {/* HERO */}
      <section className="px-6 md:px-12 pt-16 pb-12 md:pt-24 md:pb-16" style={{ background: C.navy }}>
        <div className="max-w-[1400px] mx-auto">
          <Reveal>
            <EditorialLabel text="BLOG" color={C.orange} />
            <h1
              className="text-[clamp(2.5rem,6vw,4.5rem)] leading-[1.02] tracking-tight mb-4"
              style={{ fontFamily: DISPLAY, color: C.white }}
              data-testid="blog-title"
            >
              Blog de{" "}
              <span style={{ color: C.orange }}>Emergencia Animal</span>
            </h1>
            <p className="text-lg max-w-2xl" style={{ color: "rgba(255,255,255,0.65)", lineHeight: 1.7 }}>
              Noticias, actualizaciones y reflexiones sobre protección animal en emergencias.
            </p>
          </Reveal>
        </div>
      </section>

      {/* EMPTY STATE + CTA to Guías */}
      <Section bg={C.white} testId="blog-content">
        <div className="max-w-[800px] mx-auto text-center py-12">
          <Reveal>
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center" style={{ background: `${C.orange}15`, borderRadius: 8 }}>
              <BookOpen className="w-8 h-8" style={{ color: C.orange }} />
            </div>
            <Heading size="sm" className="mb-4">Próximamente</Heading>
            <p className="text-base mb-8 max-w-md mx-auto" style={{ color: C.gray, lineHeight: 1.7 }}>
              Estamos preparando contenido nuevo para el blog. Mientras tanto, consulta nuestras guías de protección animal en la sección de Recursos.
            </p>
            <EBtn onClick={() => navigate("/recursos/ciudadania/guias")} bg={C.orange} color={C.navy} testId="blog-cta-guias">
              Ver guías para la ciudadanía <ArrowRight className="w-4 h-4" />
            </EBtn>
          </Reveal>
        </div>
      </Section>

      {/* CTA */}
      <section className="px-6 md:px-12 py-20 md:py-28" style={{ background: C.navy }}>
        <div className="max-w-[900px] mx-auto text-center">
          <Reveal>
            <Heading size="md">
              <span style={{ color: C.white }}>¿Quieres estar </span>
              <span style={{ color: C.orange }}>preparado?</span>
            </Heading>
            <p className="text-base mt-4 mb-10 max-w-lg mx-auto" style={{ color: "rgba(255,255,255,0.6)", lineHeight: 1.7 }}>
              Crea tu plan de emergencia personalizado, prepara tu mochila de vida y protege a tus animales.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <EBtn onClick={() => navigate("/prepara")} bg={C.orange} color={C.navy} testId="blog-cta-prepara">
                Ir a Prepara <ArrowUpRight className="w-4 h-4" />
              </EBtn>
              <EBtn onClick={() => navigate("/conecta")} bg={C.white} color={C.navy} testId="blog-cta-conecta">
                Conectar ahora <ArrowUpRight className="w-4 h-4" />
              </EBtn>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
